import { CommunicationTypeEnum } from "@hd/types/dto/communication/communication-type.enum";

export interface CommunicationsModalTitleModel {
  titleKey: string;
  typeLabelKey: string | null;
}

const PLAIN_TITLE_KEY = "communicationsModal.title";
const TITLE_WITH_TYPE_KEY = "communicationsModal.titleWithType";

/**
 * Il titolo della modale: se so che comunicazione sto mandando lo scrivo,
 * altrimenti resta quello generico. Torno chiavi, la t() la fa il componente
 * (stessa logica di channel-options).
 */
export function resolveCommunicationsModalTitle(
  communicationType: CommunicationTypeEnum | null,
): CommunicationsModalTitleModel {
  // != null e non falsy: uno 0 non deve passare per "tipo assente"
  if (communicationType == null) {
    return { titleKey: PLAIN_TITLE_KEY, typeLabelKey: null };
  }

  // il legacy ci manda un numero qualsiasi, il reverse mapping può non trovarlo
  const enumKey = CommunicationTypeEnum[communicationType] as
    | string
    | undefined;

  if (!enumKey) {
    return { titleKey: PLAIN_TITLE_KEY, typeLabelKey: null };
  }

  return {
    titleKey: TITLE_WITH_TYPE_KEY,
    typeLabelKey: `common.communicationTypeEnum.${enumKey}`,
  };
}
